/**
 * Represents the container type
 */ export var ContainerType = /*#__PURE__*/ function(ContainerType) {
    /** Group/Team owned  */ ContainerType["Group"] = "group";
    /** Office document owned */ ContainerType["DriveItem"] = "driveItem";
    /** Roster owned */ ContainerType["Roster"] = "roster";
    /** Project owned */ ContainerType["Project"] = "project";
    /** User container */ ContainerType["User"] = "user";
    /** Todo container */ ContainerType["ToDo"] = "todo";
    /** online meeting container */ ContainerType["OnlineMeeting"] = "onlineMeeting";
    /** Microsoft Teams Channel */ ContainerType["TeamsChannel"] = "teamsChannel";
    /** Planner Task */ ContainerType["PlannerTask"] = "plannerTask";
    return ContainerType;
}({});
